module.exports = __webpack_public_path__ + "img/numberOne.155de8a1.jpeg";